import React, { Component } from "react";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import isFunction from "lodash/isFunction";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

import { FormGroup, Input, Label } from "reactstrap";

import messages from "i18n/messages";

class FormItem extends Component {
  static defaultProps = {
    required: false,
  };

  handleChange = ({ target: { value } }) =>
    isFunction(this.props.onChange) &&
    this.props.onChange(this.props.name, value);

  render() {
    const {
      name,
      type = "text",
      disabled,
      defaultValue,
      label,
      value,
      obj,
      required,
      placeholder,
      pattern,
      validationError,
    } = this.props;
    let calcValue = value;
    if (!calcValue && obj && !isEmpty(get(obj, name)))
      calcValue = get(obj, name);
    if (isEmpty(calcValue) && defaultValue) calcValue = defaultValue;
    return (
      <FormGroup>
        <Label for={name}>
          {messages[label || name] ? (
            <FormattedMessage {...messages[label || name]} />
          ) : (
            label || name
          )}
          {required ? <span className="required-asterisk">*</span> : null}
        </Label>
        <Input
          type={type}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          pattern={pattern}
          name={name}
          id={name}
          data-value-missing={validationError || false}
          onChange={this.handleChange}
          value={calcValue || ""}
        />
      </FormGroup>
    );
  }
}

FormItem.propTypes = {
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  label: PropTypes.string,
  validationError: PropTypes.string,
  obj: PropTypes.object,
  onChange: PropTypes.func,
};

export default FormItem;
